module.exports = __webpack_public_path__ + "static/img/brees-2012-slide-8.3609286.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2012-slide-8.jpg
// module id = NKE+
// module chunks = 1